module.exports = __webpack_public_path__ + "img/weather app react native.18821711.png";